import { SortConfig } from 'store/types/Table';
import { Attendee } from 'store/types/Meeting';
import { sorter } from 'util/table';

export enum IPCheckTableActionType {
  SetInitialList = 'SetInitialList',
  UpdateSort = 'UpdateSort',
}

export interface IPCheckTableState {
  initialList: Attendee[];
  list: Attendee[];
  sort: SortConfig<Attendee>;
}

export interface IPCheckTableAction {
  type: IPCheckTableActionType;
  payload: Partial<IPCheckTableState>;
}

const getSortedList = (list: Attendee[] = [], sort: SortConfig<Attendee>): Attendee[] =>
  list.length ? [...list].sort(sorter<Attendee>(sort)) : [...list];

export const initialState: IPCheckTableState = {
  initialList: [],
  list: [],
  sort: { column: 'company', direction: 'asc' },
};

const reducer = (state: IPCheckTableState, { type, payload }: IPCheckTableAction): IPCheckTableState => {
  if (type === IPCheckTableActionType.SetInitialList) {
    const { initialList = [] } = payload;
    const list = getSortedList(initialList ?? [], state.sort);

    return { ...state, initialList, list };
  }

  if (type === IPCheckTableActionType.UpdateSort) {
    const { sort = {} } = payload;

    return {
      ...state,
      sort,
      list: getSortedList(state.initialList, sort),
    };
  }

  return state;
};

export default reducer;
